module.exports = __webpack_public_path__ + "static/media/menu-icon-active1.a8af3cba.svg";